/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Internal API
 * Внутреннее апи сервиса Channel Client Service
 * OpenAPI spec version: 1.0.0
 */
import { faker } from '@faker-js/faker';

import { HttpResponse, delay, http } from 'msw';

import { createChannelManagementInstance } from '../../api-instance';
import type { BodyType } from '../../api-instance';
export interface Channel {
  /** ID канала */
  id: string;
  /** ID владельца канала */
  owner_id: string;
  protocol: Protocol;
  status: ChannelStatus;
  /** Канал активен */
  is_active: boolean;
  name: string;
  phone: string;
}

export interface ChannelQrResponse {
  /** ID канала */
  id?: string;
  /** Ссылка для QR кода */
  qr_url: string;
  /** Время жизни QR кода */
  qr_expires: string;
  status: ChannelStatus;
}

/**
 * Данные по каналу
 */
export type ChannelCreateData = { [key: string]: unknown };

export interface ChannelCreate {
  /** ID владельца канала */
  owner_id: string;
  protocol: Protocol;
  /** Данные по каналу */
  data?: ChannelCreateData;
}

/**
 * Данные по каналу
 */
export type ChannelDetailsData = { [key: string]: unknown };

export interface ChannelDetails {
  /** ID канала */
  readonly id?: string;
  /** ID владельца канала */
  owner_id: string;
  protocol: Protocol;
  status: ChannelStatus;
  /** Канал активен */
  is_active: boolean;
  /** Данные по каналу */
  data?: ChannelDetailsData;
}

/**
 * Расширенные данные по каналу
 */
export type ChannelShortDetailsData = { [key: string]: unknown };

export interface ChannelShortDetails {
  /** ID канала */
  id: string;
  /** ID владельца канала */
  owner_id: string;
  protocol: Protocol;
  status: ChannelStatus;
  /** Канал активен */
  is_active: boolean;
  /** Расширенные данные по каналу */
  data?: ChannelShortDetailsData;
  phone: string;
}

/**
 * Данные по каналу
 */
export type ChannelUpdateData = { [key: string]: unknown };

export interface ChannelUpdate {
  is_active?: boolean;
  /** Телефонный номер канала */
  phone?: string;
  status?: ChannelStatus;
  /** Данные по каналу */
  data?: ChannelUpdateData;
}

/**
 * Протокол
 */
export type Protocol = (typeof Protocol)[keyof typeof Protocol];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Protocol = {
  telegram_personal: 'telegram_personal',
  telegram_bot: 'telegram_bot',
  whatsapp_gray: 'whatsapp_gray',
  infobip: 'infobip',
  vk: 'vk',
} as const;

/**
 * Статус канала коммуникации
 */
export type ChannelStatus = (typeof ChannelStatus)[keyof typeof ChannelStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChannelStatus = {
  unauthorized: 'unauthorized',
  pending_payment: 'pending_payment',
  qr_in_progress: 'qr_in_progress',
  password_required: 'password_required',
  required_scan_qr: 'required_scan_qr',
  authorized: 'authorized',
  contacts_synced: 'contacts_synced',
  chats_synced: 'chats_synced',
  ready: 'ready',
} as const;

export interface WorkerHealthcheck {
  /** IP пода воркера */
  ip: string;
}

export interface Worker {
  /** IP пода воркера */
  ip: string;
}

export interface TgPassword {
  /** Тг пароль */
  password: string;
}

export interface ProblemDetails {
  /** Тип ошибки */
  type: string;
  /** Название ошибки */
  title: string;
  /** Подробное описание ошибки */
  detail: string;
  /** Код состояния HTTP */
  status: number;
}

export type GetChannelsParams = {
  /**
   * Account ID
   */
  account_id: string;
};

export type GetChannelByIdParams = {
  /**
   * Возвращать data поле в ответе
   */
  with_data?: boolean;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Создание канала
 */
export const createChannel = (
  channelCreate: BodyType<ChannelCreate>,
  options?: SecondParameter<typeof createChannelManagementInstance>
) => {
  return createChannelManagementInstance<ChannelDetails>(
    {
      url: `/internal/api/v1/channel/create/`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: channelCreate,
    },
    options
  );
};

/**
 * @summary Получение канала коммуникации по channel_id для внешней ссылки
 */
export const getExternalChannelById = (
  channelId: string,
  options?: SecondParameter<typeof createChannelManagementInstance>
) => {
  return createChannelManagementInstance<ChannelQrResponse>(
    { url: `/api/v1/external/channels/${channelId}`, method: 'GET' },
    options
  );
};

/**
 * @summary Список каналов коммуникации
 */
export const getChannels = (
  params: GetChannelsParams,
  options?: SecondParameter<typeof createChannelManagementInstance>
) => {
  return createChannelManagementInstance<Channel[]>(
    { url: `/internal/api/v1/channels`, method: 'GET', params },
    options
  );
};

/**
 * @summary Обновление канала
 */
export const updateChannel = (
  channelId: string,
  channelUpdate: BodyType<ChannelUpdate>,
  options?: SecondParameter<typeof createChannelManagementInstance>
) => {
  return createChannelManagementInstance<ChannelDetails>(
    {
      url: `/internal/api/v1/channels/${channelId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: channelUpdate,
    },
    options
  );
};

/**
 * @summary Получение канала коммуникации по channel_id
 */
export const getChannelById = (
  channelId: string,
  params?: GetChannelByIdParams,
  options?: SecondParameter<typeof createChannelManagementInstance>
) => {
  return createChannelManagementInstance<ChannelShortDetails>(
    { url: `/internal/api/v1/channels/${channelId}`, method: 'GET', params },
    options
  );
};

/**
 * @summary Получение healthcheck от воркера
 */
export const putWorkerHealthcheck = (
  channelId: string,
  workerHealthcheck: BodyType<WorkerHealthcheck>,
  options?: SecondParameter<typeof createChannelManagementInstance>
) => {
  return createChannelManagementInstance<void>(
    {
      url: `/internal/api/v1/channels/${channelId}/worker/healthcheck`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: workerHealthcheck,
    },
    options
  );
};

/**
 * @summary Получение информации о развернутом воркере
 */
export const getChannelWorker = (
  channelId: string,
  options?: SecondParameter<typeof createChannelManagementInstance>
) => {
  return createChannelManagementInstance<Worker>(
    { url: `/internal/api/v1/channels/${channelId}/worker`, method: 'GET' },
    options
  );
};

/**
 * @summary Отправка пароля для авторизации по облачному паролю
 */
export const privateSendTgPersonalPassword = (
  channelId: string,
  tgPassword: BodyType<TgPassword>,
  options?: SecondParameter<typeof createChannelManagementInstance>
) => {
  return createChannelManagementInstance<void>(
    {
      url: `/api/v1/private/channels/${channelId}/tg_personal/password`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tgPassword,
    },
    options
  );
};

export type CreateChannelResult = NonNullable<
  Awaited<ReturnType<typeof createChannel>>
>;
export type GetExternalChannelByIdResult = NonNullable<
  Awaited<ReturnType<typeof getExternalChannelById>>
>;
export type GetChannelsResult = NonNullable<
  Awaited<ReturnType<typeof getChannels>>
>;
export type UpdateChannelResult = NonNullable<
  Awaited<ReturnType<typeof updateChannel>>
>;
export type GetChannelByIdResult = NonNullable<
  Awaited<ReturnType<typeof getChannelById>>
>;
export type PutWorkerHealthcheckResult = NonNullable<
  Awaited<ReturnType<typeof putWorkerHealthcheck>>
>;
export type GetChannelWorkerResult = NonNullable<
  Awaited<ReturnType<typeof getChannelWorker>>
>;
export type PrivateSendTgPersonalPasswordResult = NonNullable<
  Awaited<ReturnType<typeof privateSendTgPersonalPassword>>
>;

export const getCreateChannelResponseMock = (
  overrideResponse: Partial<ChannelDetails> = {}
): ChannelDetails => ({
  id: faker.helpers.arrayElement([faker.string.uuid(), undefined]),
  owner_id: faker.string.uuid(),
  protocol: faker.helpers.arrayElement(Object.values(Protocol)),
  status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
  is_active: faker.datatype.boolean(),
  data: faker.helpers.arrayElement([{}, undefined]),
  ...overrideResponse,
});

export const getGetExternalChannelByIdResponseMock = (
  overrideResponse: Partial<ChannelQrResponse> = {}
): ChannelQrResponse => ({
  id: faker.helpers.arrayElement([faker.string.uuid(), undefined]),
  qr_url: faker.string.alpha(20),
  qr_expires: `${faker.date.past().toISOString().split('.')[0]}Z`,
  status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
  ...overrideResponse,
});

export const getGetChannelsResponseMock = (): Channel[] =>
  Array.from(
    { length: faker.number.int({ min: 1, max: 10 }) },
    (_, i) => i + 1
  ).map(() => ({
    id: faker.string.uuid(),
    owner_id: faker.string.uuid(),
    protocol: faker.helpers.arrayElement(Object.values(Protocol)),
    status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
    is_active: faker.datatype.boolean(),
    name: faker.string.alpha(20),
    phone: faker.string.alpha(20),
  }));

export const getUpdateChannelResponseMock = (
  overrideResponse: Partial<ChannelDetails> = {}
): ChannelDetails => ({
  id: faker.helpers.arrayElement([faker.string.uuid(), undefined]),
  owner_id: faker.string.uuid(),
  protocol: faker.helpers.arrayElement(Object.values(Protocol)),
  status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
  is_active: faker.datatype.boolean(),
  data: faker.helpers.arrayElement([{}, undefined]),
  ...overrideResponse,
});

export const getGetChannelByIdResponseMock = (
  overrideResponse: Partial<ChannelShortDetails> = {}
): ChannelShortDetails => ({
  id: faker.string.uuid(),
  owner_id: faker.string.uuid(),
  protocol: faker.helpers.arrayElement(Object.values(Protocol)),
  status: faker.helpers.arrayElement(Object.values(ChannelStatus)),
  is_active: faker.datatype.boolean(),
  data: faker.helpers.arrayElement([{}, undefined]),
  phone: faker.string.alpha(20),
  ...overrideResponse,
});

export const getGetChannelWorkerResponseMock = (
  overrideResponse: Partial<Worker> = {}
): Worker => ({ ip: faker.string.alpha(20), ...overrideResponse });

export const getCreateChannelMockHandler = (
  overrideResponse?:
    | ChannelDetails
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<ChannelDetails> | ChannelDetails)
) => {
  return http.post('*/internal/api/v1/channel/create/', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getCreateChannelResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getGetExternalChannelByIdMockHandler = (
  overrideResponse?:
    | ChannelQrResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<ChannelQrResponse> | ChannelQrResponse)
) => {
  return http.get('*/api/v1/external/channels/:channelId', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetExternalChannelByIdResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getGetChannelsMockHandler = (
  overrideResponse?:
    | Channel[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<Channel[]> | Channel[])
) => {
  return http.get('*/internal/api/v1/channels', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetChannelsResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getUpdateChannelMockHandler = (
  overrideResponse?:
    | ChannelDetails
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0]
      ) => Promise<ChannelDetails> | ChannelDetails)
) => {
  return http.put('*/internal/api/v1/channels/:channelId', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getUpdateChannelResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getGetChannelByIdMockHandler = (
  overrideResponse?:
    | ChannelShortDetails
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<ChannelShortDetails> | ChannelShortDetails)
) => {
  return http.get('*/internal/api/v1/channels/:channelId', async (info) => {
    await delay(1000);

    return new HttpResponse(
      JSON.stringify(
        overrideResponse !== undefined
          ? typeof overrideResponse === 'function'
            ? await overrideResponse(info)
            : overrideResponse
          : getGetChannelByIdResponseMock()
      ),
      { status: 200, headers: { 'Content-Type': 'application/json' } }
    );
  });
};

export const getPutWorkerHealthcheckMockHandler = (
  overrideResponse?:
    | void
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0]
      ) => Promise<void> | void)
) => {
  return http.put(
    '*/internal/api/v1/channels/:channelId/worker/healthcheck',
    async (info) => {
      await delay(1000);
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }
      return new HttpResponse(null, { status: 200 });
    }
  );
};

export const getGetChannelWorkerMockHandler = (
  overrideResponse?:
    | Worker
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<Worker> | Worker)
) => {
  return http.get(
    '*/internal/api/v1/channels/:channelId/worker',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetChannelWorkerResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    }
  );
};

export const getPrivateSendTgPersonalPasswordMockHandler = (
  overrideResponse?:
    | void
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) => Promise<void> | void)
) => {
  return http.post(
    '*/api/v1/private/channels/:channelId/tg_personal/password',
    async (info) => {
      await delay(1000);
      if (typeof overrideResponse === 'function') {
        await overrideResponse(info);
      }
      return new HttpResponse(null, { status: 200 });
    }
  );
};
export const getInternalAPIMock = () => [
  getCreateChannelMockHandler(),
  getGetExternalChannelByIdMockHandler(),
  getGetChannelsMockHandler(),
  getUpdateChannelMockHandler(),
  getGetChannelByIdMockHandler(),
  getPutWorkerHealthcheckMockHandler(),
  getGetChannelWorkerMockHandler(),
  getPrivateSendTgPersonalPasswordMockHandler(),
];
